'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _notificationPropType = require('./notificationPropType');

var _notificationPropType2 = _interopRequireDefault(_notificationPropType);

var _notificationPropLevel = require('./notificationPropLevel');

var _notificationPropLevel2 = _interopRequireDefault(_notificationPropLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Notification = function (_Component) {
  (0, _inherits3.default)(Notification, _Component);

  function Notification(props) {
    (0, _classCallCheck3.default)(this, Notification);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Notification.__proto__ || (0, _getPrototypeOf2.default)(Notification)).call(this, props));

    _this.handleCloseClick = function (e) {
      e.preventDefault();
      _this.setState({ closed: true });
      if (_this.props.onCloseComplete) {
        _this.props.onCloseComplete();
      }
    };

    _this.className = function (level, type) {
      return 'quiver-notification quiver-notification--' + level + ' quiver-notification--' + type;
    };

    _this.state = {
      closed: false
    };
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Notification, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          closable = _props.closable,
          type = _props.type,
          level = _props.level;
      var closed = this.state.closed;


      if (closed) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: this.className(level, type) },
        children,
        closable ? _react2.default.createElement(
          'a',
          { className: 'quiver-notification__closable', onClick: this.handleCloseClick },
          '\u2715'
        ) : null
      );
    }
  }]);
  return Notification;
}(_react.Component);

Notification.propTypes = {
  children: _propTypes2.default.node.isRequired,
  closable: _propTypes2.default.bool,
  type: _notificationPropType2.default,
  level: _notificationPropLevel2.default,
  onCloseComplete: _propTypes2.default.func
};
Notification.defaultProps = {
  closable: false,
  level: 'information',
  type: 'small',
  onCloseComplete: null
};
exports.default = Notification;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Notification/Notification.js
// module id = 310
// module chunks = 0